import { useState, useEffect, useCallback, useRef } from "react";
import { Search } from "lucide-react";
import { ReactComponent as Trash } from "../../Assets/icon/Trash.svg";
import { ReactComponent as UserPlus } from "../../Assets/icon/user-plus-01-white.svg";
import ContactCard from "../../Components/ManageRelationshipContactcard";
import ShareElementsModal from "../../Components/ShareElementsModal";
import TopBar from "../../Components/AddRelationshipTopBar";
// import EditRelationship from "../../Components/EditRelationship";
import AddRelationshipForm from "../../Components/AddRelationshipForm";
import ConfirmInviteModal from "../../Components/ConfirmInviteModal";
import ConfirmDeleteRelationshipModal from "../../Components/ConfirmDeleteRelationshipModal";
import { getRelationships, deleteRelationship, getSentRequestsByRelationId } from "../../Services/Realtionship";
import { checkUserExists } from "../../Services/auth";
import { useHeader } from "../../Providers/HeaderContextProvider";
import PendingRequestsModal from "../../Components/PendingRequestsModal";
import EmptyState from "../../Components/AddRelationshipEmptyState";
import LoadingScreen from "../LoadingPage/ContentLoader";
import Loader from "react-js-loader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { showSuccessToast } from "../../Utils/toast";

import "./style.css";
import "../../Pages/AssessmentEncouragement/style.css";

const RelationshipsPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const isAdd = searchParams.get("isAdd");
  const isPendingRequest = searchParams.get("isPendingRequest");
  const fromInvite = searchParams.get("fromInvite");

  const isFetching = useRef(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  // Removed deprecated ManageRelationshipModal
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [showEditView, setShowEditView] = useState(false);
  const [showAddView, setShowAddView] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [allContacts, setAllContacts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showPendingView, setShowPendingView] = useState(false);
  const { setHeaderContent } = useHeader();
  const [pendingRequests, setPendingRequests] = useState([]);
  const [contactToDelete, setContactToDelete] = useState(null);
  const [showDeleteNotification, setShowDeleteNotification] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [gridloading, setGridLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const scrollRef = useRef(null);
  const [confirmInviteOpen, setConfirmInviteOpen] = useState(false);
  const [confirmInviteData, setConfirmInviteData] = useState(null);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [editInitialValues, setEditInitialValues] = useState(null);
  const [editShareContact, setEditShareContact] = useState(null);
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia('(min-width: 1024px)').matches : false
  );
  const [screenWidth, setScreenWidth] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(min-width: 1024px)');
    const handler = (e) => setIsDesktop(e.matches);
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    }
    // Fallback for very old browsers without addEventListener
    mq.onchange = handler;
    return () => { mq.onchange = null; };
  }, []);

  // Track screen width for responsive toast placement
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const onResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (showSuccess) {
      setTimeout(() => {
        setShowSuccess(false);
      }, 5000);
    }
  }, [showSuccess]);

  useEffect(() => {
    if (isAdd === "true") setShowAddView(true);
    if (isPendingRequest === "true") setShowPendingView(true);
  }, []);

  useEffect(() => {
    setHeaderContent(false);
    fetchRelationships();
  }, [selectedCategory]);


  // Build initial values for the reusable AddRelationshipForm (edit mode)
  const buildEditInitialValues = (c) => {
    if (!c) return null;
    const category = c?.related_data?.relationship_category || c?.relationship_category || c?.relationshipCategory || "";
    const type = c?.related_data?.relationship_type || c?.relationship_type || c?.relationshipType || "";
    const length = c?.related_data?.relationship_length || c?.relationship_length || c?.relationshipLength || "";
    const status = c?.related_data?.relationship_status || c?.relationship_status || c?.relationshipStatus || "";
    const email = c?.contact?.email || c?.email || "";
    const cc = c?.contact?.mobile?.country_code || c?.country_code || "";
    const local = c?.contact?.mobile?.number || "";
    return {
      first_name: c?.first_name || c?.related_data?.first_name || "",
      last_name: c?.last_name || c?.related_data?.last_name || "",
      relationship_category: category,
      relationship_type: type,
      relationship_length: length,
      relationship_status: status,
      email,
      country_code: cc,
      contact: local,
      parsed_contact: `${cc}${local}`,
      profile_pic_url: c?.profile_pic_url || c?.image_url || "",
    };
  };

  const shareStateFor = (c) => {
    const rs = c?.relation_status || c?.status;
    if (!rs) return null;
    const norm = String(rs).toLowerCase();
    if (norm === "connected" || norm === "accepted" || norm === "approved") return "accepted";
    if (norm === "pending" || norm === "requested" || norm === "awaiting" || norm === "invited") return "pending";
    return null;
  };

  // When entering edit mode, prefill initial values and, if INVITED, fetch sent request details
  useEffect(() => {
    if (!showEditView || !selectedContact) {
      setEditInitialValues(null);
      setEditShareContact(null);
      return;
    }
    // Base initial values from contact
    const base = buildEditInitialValues(selectedContact);
    setEditInitialValues(base);
    // If relationship status is INVITED fetch sent request to prefill share contact
    const status = String(selectedContact?.relation_status || selectedContact?.status || "").toLowerCase();
    const needsFetch = ["invited", "pending", "requested", "awaiting"].includes(status);
    if (!needsFetch) {
      // Use existing contact info if present
      const sc = selectedContact?.email || (selectedContact?.mobile ? `${selectedContact?.mobile?.country_code || ''} ${selectedContact?.mobile?.contact || ''}` : '');
      setEditShareContact(sc || null);
      return;
    }
    (async () => {
      try {
        const relId = selectedContact?._id;
        if (!relId) return;
        const first = await getSentRequestsByRelationId(relId);
        if (!first) return;
        const email = first?.contact?.email || "";
        const cc = first?.contact?.mobile?.country_code || "";
        const number = first?.contact?.mobile?.number || "";
        const patched = { ...base };
        if (email) {
          patched.email = email;
          setEditShareContact(email);
        } else if (cc && number) {
          patched.country_code = cc;
          patched.contact = number;
          patched.parsed_contact = `${cc}${number}`;
          setEditShareContact(`${cc} ${number}`);
        }
        setEditInitialValues(patched);
      } catch (e) {
        // fail silently – keep base values
      }
    })();
  }, [showEditView, selectedContact]);

  // Fetch relationships when component mounts or category changes
  const fetchRelationships = useCallback(async () => {
    if (isFetching.current) return; // Prevent duplicate API calls
    isFetching.current = true; // Mark as fetching

    setGridLoading(true); // Start loading indicator
    try {
      const apiCategory =
        selectedCategory === "All"
          ? ""
          : selectedCategory === "Others"
            ? "Other"
            : selectedCategory;
      const relationshipsData = await getRelationships(apiCategory);

      setContacts(relationshipsData);
      if (selectedCategory === "All") {
        setAllContacts(relationshipsData);
      }
    } catch (error) {
      console.error("Failed to fetch relationships:", error);
      setContacts([]);
    } finally {
      isFetching.current = false;
      setGridLoading(false);
      setIsLoading(false);
    }
  }, [selectedCategory]);

  // Deprecated: fetchAndSetPendingRequests removed along with fetchPendingRequests API

  const handleWheel = (event) => {
    if (scrollRef.current) {
      event.preventDefault();
      scrollRef.current.scrollLeft += event.deltaY; // Scrolls horizontally
    }
  };

  const handleAcceptRequest = async (requestId) => {
    try {
      setPendingRequests((prevRequests) =>
        prevRequests?.filter((request) => request.id !== requestId)
      );
      fetchRelationships();
    } catch (error) {
      console.error("Failed to accept request:", error);
    }
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  const handleRejectRequest = async (requestId) => {
    try {
      setPendingRequests((prevRequests) =>
        prevRequests.filter((request) => request.id !== requestId)
      );
    } catch (error) {
      console.error("Failed to reject request:", error);
    }
  };


  const handleBackClick = () => {
    if (fromInvite) {
      navigate("/dashboard");
    } else if (!showEditView && !showAddView && !showPendingView) {
      navigate(-1);
    } else {
      setShowEditView(false);
      setShowAddView(false);
      setShowPendingView(false);
      fetchRelationships();
    }
  };

  return (
      <div className="manage-container">
        <TopBar
          title={isDesktop ? "My Connections" : (showAddView ? "My Connections" : showEditView ? "Edit Connection" : "My Connections")}
          showBackButton
          onBackClick={handleBackClick}
          className="top-bar-gradient"
          smallScreenRightIcon={
            !showAddView && !showEditView && !showPendingView ? (
              <UserPlus className="relation-hover-pointer" />
            ) : null
          }
          onRightIconClick={() => {
            if (!showAddView && !showEditView && !showPendingView) {
              setSearchTerm("");
              setShowAddView(true);
              setShowEditView(false);
              setShowPendingView(false);
            }
          }}
        />

        {isLoading ? (
          <div className="manage-loading-container">
            <LoadingScreen />
          </div>
        ) : showAddView ? (
          <>
            <div className="manage-add-container">
              <AddRelationshipForm
                onCancel={() => setShowAddView(false)}
                onSuccess={(res) => {
                  if (res && (res.status === "success" || res.payload)) {
                    setShowAddView(false);
                    showSuccessToast("Connection added successfully");
                    fetchRelationships();
                  }
                  // On error, do not close; error toast already shown by service
                }}
                onCheckMember={({ via, email, country_code, contact }) => {
                  if (via === "email") {
                    return checkUserExists({ email });
                  }
                  return checkUserExists({ country_code, contact });
                }}
                openConfirmInvite={({ form, notifyVia, photo, onConfirm }) => {
                  setConfirmInviteData({ form, notifyVia, photo, onConfirm });
                  setConfirmInviteOpen(true);
                }}
              />
              {/* ConfirmInviteModal moved outside to be available for both Add and Edit flows */}
            </div>
          </>
        ) : showEditView ? (
          <div className="manage-add-container">
            <AddRelationshipForm
              mode="edit"
              relationId={selectedContact?._id}
              initialValues={editInitialValues || buildEditInitialValues(selectedContact)}
              shareState={shareStateFor(selectedContact)}
              shareContact={editShareContact || selectedContact?.email || (selectedContact?.mobile ? `${selectedContact?.mobile?.country_code || ''} ${selectedContact?.mobile?.contact || ''}` : '')}
              onCancel={() => setShowEditView(false)}
              onSuccess={(res) => {
                if (res) {
                  setShowEditView(false);
                  showSuccessToast("Connection updated");
                  fetchRelationships();
                }
                // On error, do not close; error toast already shown by service
              }}
              openConfirmInvite={({ form, notifyVia, photo, onConfirm }) => {
                setConfirmInviteData({ form, notifyVia, photo, onConfirm });
                setConfirmInviteOpen(true);
              }}
            />
          </div>
        ) : showPendingView ? (
          <PendingRequestsModal
            pendingRequestsData={pendingRequests}
            setPendingRequestsData={setPendingRequests}
            onAccept={handleAcceptRequest}
            onReject={handleRejectRequest}
          />
        ) : showAddView ||
          !Array.isArray(allContacts) ||
          allContacts.length === 0 ? ( // Show AddRelationship if contacts are null or empty
          <EmptyState onAddClick={() => setShowAddView(true)} />
        ) : (
          <div className="manage-wrapper">
            <div className="relationships-page-header">
              <h2 className="relationships-title">Connections</h2>
              <button
                className="add-relationship-btn"
                onClick={() => {
                  setSearchTerm("");
                  setShowAddView(true);
                  setShowEditView(false);
                  setShowPendingView(false);
                }}
              >
                Add Connection
              </button>
            </div>
            <div className="manage-search-container">
              <div className="manage-search-box">
                <input
                  type="text"
                  placeholder="Search by name"
                  className="manage-search-input"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Search className="manage-search-icon" size={20} />
              </div>

              <div
                className="manage-category-list"
                ref={scrollRef}
                onWheel={handleWheel}
              >
                {[
                  "All",
                  "Friends",
                  "Family",
                  "Dating",
                  "Marriage",
                  "Workplace",
                  "Roommates",
                  "Sports",
                  "Others",
                ].map((category) => (
                  <button
                    key={category}
                    className={`manage-category-button ${selectedCategory === category ? "selected" : ""
                      }`}
                    onClick={() => {
                      handleCategorySelect(category);
                    }}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>
            <div className="manage-contacts-container">
              {gridloading ? (
                <Loader
                  type="spinner-cub"
                  bgColor={"#2D50A7"}
                  color={"#3D6DEB"}
                  // title={"spinner-cub"}
                  size={45}
                />
              ) : (
                <div className="manage-contacts-grid">
                  {Array.isArray(contacts) &&
                    contacts
                      ?.filter((c) => {
                        const query = String(searchTerm || "").trim().toLowerCase();
                        if (!query) return true;
                        const first = c?.first_name || c?.related_data?.first_name || "";
                        const last = c?.last_name || c?.related_data?.last_name || "";
                        const name = `${first} ${last}`.trim().toLowerCase();
                        const nickname = String(c?.nickname || "").toLowerCase();
                        const email = String(c?.email || c?.contact?.email || "").toLowerCase();
                        return (
                          name.includes(query) ||
                          nickname.includes(query) ||
                          email.includes(query)
                        );
                      })
                      .map((contact) => (
                        <ContactCard
                          key={contact._id}
                          contact={contact}
                          onGetAdvice={(c) => {
                            if (c?._id) {
                              navigate(`/chat?relationId=${c._id}`);
                            }
                          }}
                          onEdit={(c) => {
                            setSelectedContact(c);
                            setShowEditView(true);
                          }}
                          onDelete={(c) => {
                            setContactToDelete(c);
                            setShowDeleteConfirm(true);
                          }}
                        />
                      ))}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Confirm Invite Modal: available for both Add and Edit flows */}
        <ConfirmInviteModal
          open={confirmInviteOpen}
          onClose={() => setConfirmInviteOpen(false)}
          contactName={`${confirmInviteData?.form?.first_name || ""} ${confirmInviteData?.form?.last_name || ""}`.trim()}
          category={confirmInviteData?.form?.relationship_category}
          photo={confirmInviteData?.photo}
          emailOrPhone={
            confirmInviteData?.notifyVia === "email"
              ? confirmInviteData?.form?.email
              : `${confirmInviteData?.form?.country_code || ""} ${confirmInviteData?.form?.contact || ""}`
          }
          onConfirm={async () => {
            const fn = confirmInviteData?.onConfirm;
            setConfirmInviteOpen(false);
            await fn?.();
          }}
        />

        {/* Confirm Delete Relationship Modal */}
        <ConfirmDeleteRelationshipModal
          open={showDeleteConfirm}
          contact={contactToDelete}
          onClose={() => { setShowDeleteConfirm(false); setContactToDelete(null); }}
          onConfirm={async () => {
            try {
              if (contactToDelete?._id) {
                await deleteRelationship(contactToDelete._id);
              }
              setShowDeleteConfirm(false);
              setContactToDelete(null);
              // Optimistic UI updates + refresh
              setContacts((prev) => prev.filter((c) => c._id !== (contactToDelete?._id)));
              // setShowDeleteNotification(true);
              showSuccessToast("Relationship has been removed");
              setTimeout(() => setShowDeleteNotification(false), 2000);
              await fetchRelationships();
            } catch (e) {
              console.error('Failed to delete contact:', e);
              setShowDeleteConfirm(false);
            }
          }}
        />

        {showDeleteNotification && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div className="delete-notification">
              <Trash />
              Relationship has been removed
            </div>
          </div>
        )}
        {showSuccess && (
          <p
            style={{
              color: "green",
              width: "100%",
              textAlign: "'center",
              marginTop: "10px",
            }}
          >
            Connection request sent successfully
          </p>
        )}
        {/* Share Aris Elements Modal */}
        <ShareElementsModal
          open={shareModalOpen}
          contact={selectedContact}
          onClose={() => setShareModalOpen(false)}
          onConfirmed={async () => {
            setShareModalOpen(false);
            await fetchRelationships();
          }}
        />
      </div>
  );
};

export default RelationshipsPage;
